module.exports = __webpack_public_path__ + "img/earth-africa.e74123f8.svg";